<div class="animated fadeIn">

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body" style="min-height: 600px;">
                <div class="row form-group" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                <strong class="card-title">Quick Links</strong>
                            </div>
                            <div class="card-body" > 
                                <div class="row form-group">
                                    <div class="col-md-12" *ngIf="userRole=='admin'">
                                    	
                                    	<button style="height: 60px; width: 130px;" type="submit" class="btn btn-primary" (click)="gotoFileMatrix()" >File Matrix</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px;" type="submit" class="btn btn-primary" (click)="gotoUploadedFiles()" >Uploaded Files</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px; white-space: normal !important" type="submit" class="btn btn-primary" (click)="gotoConsolidatedReports()" >Consolidated Reports</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px; white-space: normal !important" type="submit" class="btn btn-primary" (click)="gotoCustomReports()" >Custom Reports</button>
                                    </div>

                                    <div class="col-md-12" *ngIf="userRole=='analyst'">
                                    	
                                    	<button style="height: 60px; width: 130px;" type="submit" class="btn btn-primary" (click)="gotoFlashUpload()" >Flash Upload</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px;" type="submit" class="btn btn-primary" (click)="gotoFileUpload()" >File Upload</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px;" type="submit" class="btn btn-primary" (click)="gotoUploadedFilesAnalyst()" >Uploaded Files</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px; white-space: normal !important" type="submit" class="btn btn-primary" (click)="gotoConsolidatedReportsAnalyst()" >Consolidated Reports</button>

                                    	<button style="height: 60px; width: 130px; margin-left: 15px; white-space: normal !important" type="submit" class="btn btn-primary" (click)="gotoCustomReportsAnalyst()" >Custom Reports</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row form-group" >
	                <div class="col col-md-12">
	                    <div class="card border border-success">
	                        <div class="card-header">
	                            <strong class="card-title">Total Number of Uploaded Files : {{totalRows}}</strong>
	                            <br><br>
	                            <strong class="card-title">Last 10 Uploaded Files :</strong>
	                        </div>

	                        <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">

			                    <thead>
			                        <tr role="row">
			                            <th>Name</th>
			                            <th>Type</th>
			                            <th>Month</th>
			                            <th>Quarter</th>
			                            <th>Year</th>
			                            <th *ngif="userRole=='admin'">Insurer</th>
			                        </tr>
			                    </thead>
			                    <tbody> 
				                    <tr role="row" class="odd" *ngFor="let fdata of fileData">
				                        <td>{{ fdata.fileName }}</td>
				                        <td>{{ fdata.templateType }}</td>
				                        <td>{{ fdata.monthly ?fdata.monthly:'N/A'}}</td>
				                        <td>{{ fdata.quarterly ?fdata.quarterly:'N/A'}}</td>
				                        <td>{{ fdata.year }}</td>
				                        <td *ngif="userRole=='admin'">{{ fdata.companyName }}</td>
				                    </tr> 
				                                            
				                </tbody>
			                </table>
	                    </div>
	                </div>
                </div> -->
            </div>
        </div>
    </div>

</div>
</div><!-- .animated -->

